import { useMainStore } from "@/stores/mainStore";
import gsap from "gsap";

const anim = gsap.timeline({paused:true});

    
export const modalShow = (element, type) => {
    const mainStore = useMainStore();
    if(type === 'primary'){
        anim.add(mainStore.isModalPrimaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.play();
    }else if( type === 'secondary'){
        anim.add(mainStore.isModalSecondaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.play();
    }else if( type==="tertiary"){
        anim.add(mainStore.isModalTertiaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.play();
    }else if( type==="quaternary"){
        anim.add(mainStore.isModalQuaternaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.play();
    }else if( type==="quinquenary"){
        anim.add(mainStore.isModalQuinquenaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.play();
    }
    
}

export const modalShowFull = (element, element_b ,type) => {
    const mainStore = useMainStore();
    if(type === 'primary'){
        anim.add(mainStore.isModalPrimaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.to(element_b,{scale:1,duration:.0});
        anim.play();
    }else if( type === 'secondary'){
        anim.add(mainStore.isModalSecondaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.to(element_b,{scale:1,duration:.0});
        anim.play();
    }else if( type==="tertiary"){
        anim.add(mainStore.isModalTertiaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.to(element_b,{scale:1,duration:.0});
        anim.play();
    }else if( type==="quaternary"){
        anim.add(mainStore.isModalQuaternaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.to(element_b,{scale:1,duration:.0});
        anim.play();
    }else if( type==="quinquenary"){
        anim.add(mainStore.isModalQuinquenaryVisible = true);
        anim.to(element,{scale:1,duration:.2});
        anim.to(element_b,{scale:1,duration:.0});
        anim.play();
    }
    
}

export const modalHide = (element, type) => {
    const mainStore = useMainStore();
    if(type === 'primary'){
        anim.add(mainStore.isModalPrimaryVisible = false);
        anim.to(element,{scale:0,duration:.2});
        anim.play();
    }else if( type === 'secondary'){
        anim.add(mainStore.isModalSecondaryVisible = false);
        anim.to(element,{scale:0,duration:.2});
        anim.play();
    }else if(type === 'tertiary'){
        anim.add(mainStore.isModalTertiaryVisible = false);
        anim.to(element,{scale:0,duration:.2});
        anim.play();
    }else if( type==="quaternary"){
        anim.add(mainStore.isModalQuaternaryVisible = false);
        anim.to(element,{scale:0,duration:.2});
        anim.play();
    }
    
}

export const bottomMenuShow = (element) =>{
    const mainStore = useMainStore();
    if(mainStore.isBottomBarActive === false){
        anim.add(mainStore.isBottomBarActive = true);
        anim.add(document.querySelector('.bottom_menu').style.backgroundColor='#2B282C');
        anim.add(document.querySelector('.bottom_menu').style.borderRadius='24px');
        anim.to(element,{scale:1,duration:.2});
        anim.play();
    }else{
        anim.add(mainStore.isBottomBarActive = false);
        anim.add(document.querySelector('.bottom_menu').style.backgroundColor='transparent');
        anim.add(document.querySelector('.bottom_menu').style.borderRadius='0px');
        anim.to(element,{scale:0,duration:.2})
        anim.play();
    }
}
